<div class="flex flex-col gap-(--capturecard-gap) h-full">
  @if (config().title) {
    <app-dynamic
      componentName="DynamicText"
      [props]="{ config: config().title }"
    />
  }
  @if (config().infoBanner) {
    <app-dynamic
      componentName="InfoBanner"
      [props]="{ config: config().infoBanner }"
    />
  }

  <div class="flex-1 flex items-center justify-center">
    <div
      #cameraPreview
      [id]="config().cameraPreviewId ?? 'cameraPreview'"
      class="relative max-w-125 rounded-(--capturecard-preview-border-radius) overflow-hidden bg-(--capturecard-preview-background)"
    >
      @if (capturedImage() && disabled()) {
        <img
          [src]="'data:image/jpeg;base64,' + capturedImage()"
          alt=""
          class="absolute inset-0 w-full h-full object-cover"
        />
      }
    </div>
  </div>

  <div class="flex justify-center">
    <button
      type="button"
      [attr.aria-label]="config().captureButtonAriaLabel"
      [disabled]="disabled()"
      class="w-16 h-16 rounded-full bg-(--capturecard-button-background) flex items-center justify-center cursor-pointer disabled:opacity-50"
      (click)="onCapture()"
    >
      <div class="w-13 h-13 rounded-full border-2 border-(--capturecard-button-border-color) bg-transparent"></div>
    </button>
  </div>
</div>
